// Breakpoints adapted from The Verge's configuration
export const BREAKPOINTS = {
  mobile: 0,
  productCard: 335,
  productCardDesktop: 550,
  river: 700,
  narrowRiver: 600, // verge homepage
  tablet: 768,
  navigation: 901, // when the navigation switches layout
  desktop: 1180,
};
